<div class="grid gap-6 py-2 md:grid-cols-3" *ngIf="registro">
  <div class="min-w-0 space-y-4 md:col-span-2">
    <div *ngIf="registro.motivo">
      <p class="m-0 mb-1 text-xs font-medium text-foreground">{{ registro.estado === 'OMITIDO' ? 'Por qué no corrió' : (registro.estado === 'FALLA' ? 'Por qué falló' : 'Motivo') }}</p>
      <!-- Un motivo compuesto (« || ») va una parte por renglón; el código crudo, en el `title`. -->
      <ul class="m-0 list-none space-y-0.5 p-0 text-sm text-muted-foreground" [title]="registro.motivo || ''">
        <li class="!my-0" *ngFor="let parte of partesDelMotivo(registro.motivo)">{{ parte }}</li>
      </ul>
    </div>
    <div *ngIf="registro.pregunta">
      <p class="m-0 mb-1 text-xs font-medium text-foreground">Lo que se preguntó</p>
      <p class="m-0 whitespace-pre-wrap text-sm">{{ registro.pregunta }}</p>
    </div>
    <div *ngIf="textoRespuesta">
      <p class="m-0 mb-1 text-xs font-medium text-foreground">Lo que se contestó</p>
      <p class="m-0 whitespace-pre-wrap text-sm text-muted-foreground">{{ textoRespuesta }}</p>
    </div>
    <div *ngIf="tablaRespuesta" class="overflow-x-auto rounded-md border border-border bg-card">
      <table class="kb-table">
        <thead class="kb-thead">
          <tr><th class="kb-th" *ngFor="let c of tablaRespuesta.columnas; let i = index" [class.kb-th-num]="columnaNumerica(i)">{{ c }}</th></tr>
        </thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let f of tablaRespuesta.filas">
            <td class="kb-td" *ngFor="let v of f; let j = index" [class.kb-td-num]="columnaNumerica(j)">{{ celda(v, formato(j)) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="respuestaCruda">
      <p class="m-0 mb-1 text-xs font-medium text-foreground">Lo que se contestó</p>
      <pre class="m-0 max-h-64 overflow-auto rounded-md bg-background p-3 font-mono text-[11px] leading-relaxed">{{ respuestaCruda }}</pre>
    </div>
    <div *ngIf="peticion">
      <p class="m-0 mb-1 text-xs font-medium text-foreground">La consulta que se armó</p>
      <pre class="m-0 max-h-64 overflow-auto rounded-md bg-background p-3 font-mono text-[11px] leading-relaxed">{{ peticion }}</pre>
    </div>
    <p class="m-0 text-sm text-muted-foreground"
       *ngIf="!registro.motivo && !registro.pregunta && !textoRespuesta && !peticion">No quedó anotado nada más de esta línea.</p>
  </div>

  <dl class="m-0 space-y-1.5 text-xs">
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Cuándo</dt><dd class="kb-fila-valor m-0">{{ fechaHora(registro.creadoEl) }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Agente</dt><dd class="kb-fila-valor m-0">{{ tituloAgente(registro.agente) }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Tipo</dt><dd class="kb-fila-valor m-0">{{ etiquetaFila(registro) }}</dd></div>
    <div class="kb-fila !py-0.5" *ngIf="registro.comercio"><dt class="kb-fila-label">Comercio</dt><dd class="kb-fila-valor m-0 font-mono">{{ registro.comercio }}</dd></div>
    <div class="kb-fila !py-0.5" *ngIf="registro.usuario"><dt class="kb-fila-label">Usuario</dt><dd class="kb-fila-valor m-0">{{ registro.usuario }}</dd></div>
    <div class="kb-fila !py-0.5" *ngIf="registro.pantalla"><dt class="kb-fila-label">Pantalla del portal</dt><dd class="kb-fila-valor m-0 font-mono">{{ registro.pantalla }}</dd></div>
    <div class="kb-fila !py-0.5" *ngIf="registro.intencion"><dt class="kb-fila-label">Intención</dt><dd class="kb-fila-valor m-0">{{ registro.intencion }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Proveedor</dt><dd class="kb-fila-valor m-0">{{ registro.proveedor ? nombreProveedor(registro.proveedor) : '—' }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Modelo</dt><dd class="kb-fila-valor m-0 font-mono">{{ registro.modeloId || '—' }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Filas devueltas</dt><dd class="kb-fila-valor m-0">{{ nf(registro.filas) }}</dd></div>
    <div class="kb-fila !py-0.5" *ngIf="registro.herramientas?.length"><dt class="kb-fila-label">Herramientas</dt><dd class="kb-fila-valor m-0">{{ registro.herramientas?.join(', ') }}</dd></div>
    <div class="kb-fila !py-0.5" *ngIf="registro.fichas?.length"><dt class="kb-fila-label">Fichas</dt><dd class="kb-fila-valor m-0">{{ registro.fichas?.join(', ') }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Tokens (entrada / salida)</dt><dd class="kb-fila-valor m-0 tabular-nums">{{ nf(registro.tokensEntrada) }} / {{ nf(registro.tokensSalida) }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Tardó</dt><dd class="kb-fila-valor m-0 tabular-nums">{{ ms(registro.latenciaMs) }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Costo</dt><dd class="kb-fila-valor m-0 tabular-nums">{{ usd(registro.costoUsd) }}</dd></div>
    <div class="kb-fila !py-0.5"><dt class="kb-fila-label">Identificador</dt><dd class="kb-fila-valor m-0 break-all font-mono">{{ registro.traceId || '—' }}</dd></div>

    <div class="pt-2" *ngIf="registro._id">
      <p class="m-0 mb-1.5 text-xs text-muted-foreground">
        ¿Estuvo bien?
        <ng-container *ngIf="registro.humanoDeAcuerdo === true"> · dijiste que sí</ng-container>
        <ng-container *ngIf="registro.humanoDeAcuerdo === false"> · dijiste que no</ng-container>
        <ng-container *ngIf="registro.humanoPor"> · {{ registro.humanoPor }}</ng-container>
      </p>
      <div class="flex gap-1.5">
        <button type="button" class="kb-btn kb-btn-outline kb-btn-icon" [disabled]="opinando"
                [class.kb-chip-activo]="registro.humanoDeAcuerdo === true"
                title="Estuvo bien" aria-label="Estuvo bien" (click)="opinar(true)">
          <i class="fas fa-thumbs-up !text-foreground" aria-hidden="true"></i></button>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-icon" [disabled]="opinando"
                [class.kb-chip-activo]="registro.humanoDeAcuerdo === false"
                title="Estuvo mal" aria-label="Estuvo mal" (click)="opinar(false)">
          <i class="fas fa-thumbs-down !text-foreground" aria-hidden="true"></i></button>
      </div>
      <p class="kb-error" *ngIf="errorOpinion">{{ errorOpinion }}</p>
    </div>
  </dl>
</div>
